import { useLazyQuery } from "@apollo/client/react"; import { useMemo, useState } from "react";
import { generateColumnsDefaultConfiguration } from "../../../../../components/dataGrid/columnHelpers";
import AttachFileIcon from '@mui/icons-material/AttachFile';

import { GET_PDF_VISITA } from '../../../../../data/graphQL/queries/ImprimirVisita/getPDFVisita';

export function useTabDocumentacionVisitasNuevas(visitas) {

  const [fileToViewNuevas, setFileToViewNuevas] = useState();

  const [getDocumentoById] = useLazyQuery(GET_PDF_VISITA, {
    fetchPolicy: 'no-cache'
  });

  const handleClickView = async (row) => {
    const response = await getDocumentoById({
      variables: {
        idVisita: row?.idVisita
      }
    });
    setFileToViewNuevas({
      archivo: response?.data.imprimirVisitaDetalle,
      extension: '.pdf',
      titulo: 'Visita ' + row?.idVisita,
      contentType: 'application/pdf'
    });
  };

  const resetFileToViewNuevas = () => setFileToViewNuevas();

  const initialColumns = [
    { width: 0.1, field: "Hidden", headerName: "", hide: true },
    {
      flex: 4,
      field: "tipoProfesional",
      headerName: "Tipo profesional"
    },
    {
      flex: 6,
      field: "profesional",
      headerName: "Profesional"
    },
    {
      flex: 2,
      field: "fechaVisita",
      headerName: "Fecha Visita"
    },
    {
      headerName: "",
      field: "action",
      align: "center",
      flex: 1,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <div
            aria-hidden="true"
            onClick={() => handleClickView(row)}
            className="clickable-option">

            <AttachFileIcon className="edit-icon" sx={{ paddingTop: '5px' }} />
          </div>);

      }
    }];


  const columnsNuevas = useMemo(
    () => generateColumnsDefaultConfiguration(initialColumns),
    [visitas]
  );

  return { columnsNuevas, fileToViewNuevas, resetFileToViewNuevas };
}